module.exports = __webpack_public_path__ + "static/img/smelter_256.cac9564.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smelter_256.png
// module id = QrhS
// module chunks = 0